import React, { useEffect } from "react";
import { useState } from "react";
import {Route, Routes } from 'react-router-dom';
import {getDatabase, onValue, ref, set as firebaseSet} from 'firebase/database';
import { StyledFirebaseAuth } from "react-firebaseui";

import { getAuth, GoogleAuthProvider, EmailAuthProvider} from 'firebase/auth';

const FIREBASEUI_CONFIG = {
    signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
        { provider: EmailAuthProvider.PROVIDER_ID, requireDisplayName: true}
    ],
    signInFlow: 'popup', //show popup to login
    credentialHelper: 'none', // don't show an account chooser
    callbacks: {
        signInSuccessWithAuthResult: () => false // do nothing special, just return false. Prevent Default
    }
}



export function SignInPage() {
    const auth = getAuth();// the authenticator

    return (
        <div>
            <div className="signIn">
                {/*console.log('sign in')*/}
                <StyledFirebaseAuth uiConfig={FIREBASEUI_CONFIG} firebaseAuth={auth}/>
            </div>
        </div>
    );
}
